/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_Erasure_DescInputs */

const en_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) — Request deletion of your personal data`)
};

const de_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) -- Beantragen Sie die Löschung Ihrer personenbezogenen Daten`)
};

const fr_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) -- Demander la suppression de vos données personnelles`)
};

const es_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) -- Solicitar la eliminación de sus datos personales`)
};

const it_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) — Richiedere la cancellazione dei tuoi dati personali`)
};

const nl_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) — Verwijdering van uw persoonlijke gegevens verzoeken`)
};

const pl_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) — Żądanie usunięcia swoich danych osobowych`)
};

const fi_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (artikla 17) — Pyydä henkilötietojesi poistamista`)
};

const da_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) — Anmod om sletning af dine persondata`)
};

const sv_privacy_rights_item_erasure_desc = /** @type {(inputs: Privacy_Rights_Item_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 17) — Begär radering av dina personuppgifter`)
};

/**
* | output |
* | --- |
* | "(Art. 17) — Request deletion of your personal data" |
*
* @param {Privacy_Rights_Item_Erasure_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_erasure_desc = /** @type {((inputs?: Privacy_Rights_Item_Erasure_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_Erasure_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_erasure_desc(inputs)
	if (locale === "fr") return fr_privacy_rights_item_erasure_desc(inputs)
	if (locale === "es") return es_privacy_rights_item_erasure_desc(inputs)
	if (locale === "it") return it_privacy_rights_item_erasure_desc(inputs)
	if (locale === "nl") return nl_privacy_rights_item_erasure_desc(inputs)
	if (locale === "pl") return pl_privacy_rights_item_erasure_desc(inputs)
	if (locale === "fi") return fi_privacy_rights_item_erasure_desc(inputs)
	if (locale === "da") return da_privacy_rights_item_erasure_desc(inputs)
	if (locale === "sv") return sv_privacy_rights_item_erasure_desc(inputs)
	return en_privacy_rights_item_erasure_desc(inputs)
});